// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"b0957e3e","3375":"b0957e3e"}[chunkId] + ".chunk.css";
};